var avatar = 'fx_2d2fb1e5_1ara3ml6';
var avatarBackground = 'var(--fx_2d2fb1e5_1ara3ml3)';
var avatarFontSize = 'var(--fx_2d2fb1e5_1ara3ml1)';
var avatarFontWeight = 'var(--fx_2d2fb1e5_1ara3ml2)';
var avatarIconSize = 'var(--fx_2d2fb1e5_1ara3ml4)';
var avatarRoot = 'fx_2d2fb1e5_1ara3ml5';
var avatarSize = 'var(--fx_2d2fb1e5_1ara3ml0)';

export { avatar, avatarBackground, avatarFontSize, avatarFontWeight, avatarIconSize, avatarRoot, avatarSize };
//# sourceMappingURL=avatar.vanilla.mjs.map
